export enum UserType {
    OWNER = 'owner',
    REVIEWER = 'reviewer',
}
